// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu-portal .menu-item {
  box-sizing: border-box;
}

.dropdown-menu-portal .menu-item-with-submenu > .language-submenu {
  position: absolute;
  top: 0;
  right: calc(100% - 1px);
  box-sizing: border-box;
  min-width: 180px;
  overflow: visible;
  z-index: 20001;
}

.dropdown-menu-portal .menu-item-with-submenu > .language-submenu.language-submenu--open-upward {
  top: auto;
  bottom: 0;
}

.dropdown-menu-portal.dropdown-menu-portal--submenus-right .menu-item-with-submenu > .language-submenu {
  right: auto;
  left: calc(100% - 1px);
}

.dropdown-menu-portal .menu-item-with-submenu > .language-submenu.report-submenu-wide {
  min-width: 220px;
}

.language-menu-item {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.language-badge {
  min-width: 2.2rem;
  padding: 0.18rem 0.45rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #f8fafc;
  color: #475569;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-align: center;
}

.language-name {
  white-space: nowrap;
}

.dark .language-badge {
  background: #374151;
  border-color: #4b5563;
  color: #d1d5db;
}

.language-menu-item.active .language-badge {
  border-color: currentColor;
}

.compact-account-menu {
  min-width: 170px;
  max-width: min(220px, calc(100vw - 16px));
}

.compact-options-overlay {
  position: fixed;
  inset: 0;
  z-index: 60000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.32);
}

.compact-options-panel {
  width: min(21rem, calc(100vw - 2rem));
  height: min(32rem, calc(100dvh - 2rem));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: var(--surface-color);
  color: #1f2937;
}

.compact-options-overlay.dark .compact-options-panel {
  background: #111827;
  border-color: #374151;
  color: #f9fafb;
}

.compact-options-header {
  display: grid;
  grid-template-columns: 2rem minmax(0, 1fr) 2rem;
  align-items: center;
  gap: 0.4rem;
  padding: 0.75rem 0.8rem;
  border-bottom: 1px solid #e5e7eb;
}

.compact-options-overlay.dark .compact-options-header {
  border-bottom-color: #374151;
}

.compact-options-header h3 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  text-align: center;
}

.compact-options-back,
.compact-options-close {
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
}

.compact-options-back {
  font-size: 1.6rem;
  line-height: 1;
}

.compact-options-close svg {
  width: 1.05rem;
  height: 1.05rem;
}

.compact-options-back:hover,
.compact-options-close:hover {
  color: #1f2937;
}

.compact-options-overlay.dark .compact-options-back,
.compact-options-overlay.dark .compact-options-close {
  color: #9ca3af;
}

.compact-options-overlay.dark .compact-options-back:hover,
.compact-options-overlay.dark .compact-options-close:hover {
  color: #f9fafb;
}

.compact-options-back-spacer {
  width: 2rem;
  height: 2rem;
}

.compact-options-body {
  overflow-y: auto;
  padding: 0.35rem 0;
}

.compact-options-body .menu-item {
  padding: 0.72rem 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/report/ReportHamburgerMenu.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".dropdown-menu-portal .menu-item {\n  box-sizing: border-box;\n}\n\n.dropdown-menu-portal .menu-item-with-submenu > .language-submenu {\n  position: absolute;\n  top: 0;\n  right: calc(100% - 1px);\n  box-sizing: border-box;\n  min-width: 180px;\n  overflow: visible;\n  z-index: 20001;\n}\n\n.dropdown-menu-portal .menu-item-with-submenu > .language-submenu.language-submenu--open-upward {\n  top: auto;\n  bottom: 0;\n}\n\n.dropdown-menu-portal.dropdown-menu-portal--submenus-right .menu-item-with-submenu > .language-submenu {\n  right: auto;\n  left: calc(100% - 1px);\n}\n\n.dropdown-menu-portal .menu-item-with-submenu > .language-submenu.report-submenu-wide {\n  min-width: 220px;\n}\n\n.language-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n}\n\n.language-badge {\n  min-width: 2.2rem;\n  padding: 0.18rem 0.45rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-align: center;\n}\n\n.language-name {\n  white-space: nowrap;\n}\n\n.dark .language-badge {\n  background: #374151;\n  border-color: #4b5563;\n  color: #d1d5db;\n}\n\n.language-menu-item.active .language-badge {\n  border-color: currentColor;\n}\n\n.compact-account-menu {\n  min-width: 170px;\n  max-width: min(220px, calc(100vw - 16px));\n}\n\n.compact-options-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 60000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.32);\n}\n\n.compact-options-panel {\n  width: min(21rem, calc(100vw - 2rem));\n  height: min(32rem, calc(100dvh - 2rem));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  background: var(--surface-color);\n  color: #1f2937;\n}\n\n.compact-options-overlay.dark .compact-options-panel {\n  background: #111827;\n  border-color: #374151;\n  color: #f9fafb;\n}\n\n.compact-options-header {\n  display: grid;\n  grid-template-columns: 2rem minmax(0, 1fr) 2rem;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.75rem 0.8rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.compact-options-overlay.dark .compact-options-header {\n  border-bottom-color: #374151;\n}\n\n.compact-options-header h3 {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  text-align: center;\n}\n\n.compact-options-back,\n.compact-options-close {\n  width: 2rem;\n  height: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0;\n}\n\n.compact-options-back {\n  font-size: 1.6rem;\n  line-height: 1;\n}\n\n.compact-options-close svg {\n  width: 1.05rem;\n  height: 1.05rem;\n}\n\n.compact-options-back:hover,\n.compact-options-close:hover {\n  color: #1f2937;\n}\n\n.compact-options-overlay.dark .compact-options-back,\n.compact-options-overlay.dark .compact-options-close {\n  color: #9ca3af;\n}\n\n.compact-options-overlay.dark .compact-options-back:hover,\n.compact-options-overlay.dark .compact-options-close:hover {\n  color: #f9fafb;\n}\n\n.compact-options-back-spacer {\n  width: 2rem;\n  height: 2rem;\n}\n\n.compact-options-body {\n  overflow-y: auto;\n  padding: 0.35rem 0;\n}\n\n.compact-options-body .menu-item {\n  padding: 0.72rem 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
